import React from 'react';

const JobStep = ({ answers, setAnswers }) => {
  const jobOptions = [
    'کارمند / کارشناس',
    'دانشجو / دانش‌آموز',
    'خانم خانه‌دار',
    'خوداشتغال / فریلنسر',
    'مدیر / سرپرست',
    'پزشک / پرستار',
    'معلم / استاد',
    'فروشنده / مغازه‌دار',
    'بیکار / در جستجوی کار',
    'سایر'
  ];

  const handleSelect = (job) => {
    setAnswers(prev => ({
      ...prev,
      job
    }));
  };

  return (
    <div className="text-center">
      <h2 className="text-2xl font-bold mb-6 text-gray-800">
        لطفا شغل یا نوع فعالیت‌تون رو انتخاب کنید
      </h2>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-2xl mx-auto">
        {jobOptions.map((job) => (
          <button
            key={job}
            onClick={() => handleSelect(job)}
            className={`w-full py-4 px-4 rounded-xl border-2 transition-all duration-200 focus:outline-none text-right ${
              answers.job === job
                ? 'border-indigo-600 bg-indigo-600 text-white shadow-lg'
                : 'border-gray-300 hover:border-indigo-400 hover:bg-indigo-50 text-gray-700'
            }`}
          >
            <span className="text-sm font-medium">{job}</span>
          </button>
        ))}
      </div>

      {/* Additional Info */}
      <div className="mt-6 p-4 bg-gray-50 rounded-lg max-w-2xl mx-auto">
        <p className="text-xs text-gray-600">
          انتخاب شغل به ما کمک می‌کنه تا توصیه‌های بهتری برای مراقبت از پوست‌تون ارائه بدیم
        </p>
      </div>
    </div>
  );
};

export default JobStep; 